module.exports = __webpack_public_path__ + "img/alt7.075f880e.jpg";